/**
 * Renaissance Tea : barre d'achat collante sur mobile (fiches produit).
 *
 * - Visible seulement sous 750 px, quand le bouton « Ajouter au panier » principal est
 *   sorti de l'écran par le haut (IntersectionObserver), et masquée tant que le bandeau
 *   cookies Shopify est ouvert.
 * - Le bouton « Ajouter » clique le bouton principal du formulaire #product-form-main :
 *   même variante (input name="id"), même quantité (#productQuantity, form="product-form-main"),
 *   même gestionnaire d'envoi (rt-ajax-add-to-cart.js). Aucun second fetch ici, donc pas
 *   de double ajout.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';

  function formatMoney(cents, format) {
    if (window.rtFreeShippingBar && typeof window.rtFreeShippingBar.formatMoney === 'function') {
      return window.rtFreeShippingBar.formatMoney(cents, format);
    }
    return ((cents || 0) / 100).toFixed(2).replace('.', ',') + '€';
  }

  function init() {
    var bar = document.querySelector('[data-rt-satc]');
    var form = document.getElementById('product-form-main');
    if (!bar || !form || bar.dataset.rtSatcReady) return;
    bar.dataset.rtSatcReady = 'true';

    var mainBtn = form.querySelector('button[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    var variantInput = form.querySelector('input[name="id"]');
    var addBtn = bar.querySelector('[data-rt-satc-add]');
    var variantEl = bar.querySelector('[data-rt-satc-variant]');
    var priceEl = bar.querySelector('[data-rt-satc-price]');
    var moneyFormat = bar.getAttribute('data-money-format');
    var mq = window.matchMedia(MOBILE_QUERY);
    var root = document.documentElement;

    if (!mainBtn || !addBtn || !('IntersectionObserver' in window)) return;

    var variants = {};
    try {
      var json = bar.querySelector('[data-rt-satc-variants]');
      if (json) variants = JSON.parse(json.textContent);
    } catch (e) {
      variants = {};
    }

    var mainVisible = true;
    var mainReached = false;

    function quantity() {
      var input = document.getElementById('productQuantity') || form.querySelector('[name="quantity"]');
      var q = input ? parseInt(input.value, 10) : 1;
      return q > 0 ? q : 1;
    }

    function syncContent() {
      var v = variantInput ? variants[variantInput.value] : null;
      var q = quantity();
      if (v) {
        if (variantEl) variantEl.textContent = q > 1 ? v.title + ' × ' + q : v.title;
        if (priceEl) priceEl.textContent = formatMoney(v.price * q, moneyFormat);
      }
      var unavailable = mainBtn.disabled && !mainBtn.classList.contains('loading');
      addBtn.disabled = !!unavailable || (v ? v.available === false : false);
    }

    function cookieBannerOpen() {
      var banner = document.getElementById('shopify-pc__banner');
      if (!banner) return false;
      var cs = window.getComputedStyle(banner);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
      var r = banner.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight;
    }

    function setVisible(show) {
      if (bar.classList.contains('is-visible') === show) return;
      bar.classList.toggle('is-visible', show);
      if (show) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
        root.style.setProperty('--rt-satc-h', bar.offsetHeight + 'px');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
      root.classList.toggle('rt-satc-on', show);
    }

    function evaluate() {
      // Barre seulement si le bouton principal est sorti de l'écran par le haut.
      var show = mq.matches && !mainVisible && mainReached && !cookieBannerOpen();
      if (show) syncContent();
      setVisible(show);
    }

    // Deux observateurs : un saut de défilement (ancre, retour en haut) peut faire passer le
    // bouton de « sous l'écran » à « au-dessus » sans jamais l'afficher ; le premier seul ne
    // se déclencherait pas.
    // 1. Le bouton est-il à l'écran ?
    new IntersectionObserver(
      function (entries) {
        mainVisible = entries[entries.length - 1].isIntersecting;
        evaluate();
      },
      { threshold: 0 }
    ).observe(mainBtn);
    // 2. Le bouton est-il au-dessus du bas de l'écran (déjà atteint) ? Zone d'observation
    //    prolongée très loin vers le haut.
    new IntersectionObserver(
      function (entries) {
        mainReached = entries[entries.length - 1].isIntersecting;
        evaluate();
      },
      { threshold: 0, rootMargin: '100000px 0px 0px 0px' }
    ).observe(mainBtn);

    addBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (mainBtn.disabled || mainBtn.classList.contains('loading') || addBtn.classList.contains('is-loading')) return;
      // Même chemin que le bouton principal : clic natif -> submit -> rt-ajax-add-to-cart.js
      mainBtn.click();
    });

    // Reflète l'état de chargement du bouton principal (pendant l'ajout AJAX).
    new MutationObserver(function () {
      addBtn.classList.toggle('is-loading', mainBtn.classList.contains('loading'));
      if (bar.classList.contains('is-visible')) syncContent();
    }).observe(mainBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });

    // Variante ou quantité changée sur la fiche : les gestionnaires de la page ont déjà tourné.
    document.addEventListener('click', function (event) {
      if (event.target.closest('.product-custom__variant-btn, .product-custom__qty-btn')) {
        window.requestAnimationFrame(syncContent);
      }
    });
    document.addEventListener('input', function (event) {
      if (event.target && event.target.id === 'productQuantity') syncContent();
    });
    document.addEventListener('change', function (event) {
      if (event.target && event.target.id === 'productQuantity') syncContent();
    });

    // Bandeau cookies fermé, rotation, passage ordinateur <-> mobile.
    document.addEventListener('visitorConsentCollected', function () {
      window.setTimeout(evaluate, 400);
    });
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', evaluate);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(evaluate);
    }
    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-visible')) root.style.setProperty('--rt-satc-h', bar.offsetHeight + 'px');
    });

    syncContent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
